// extracted by mini-css-extract-plugin
export default {"CheckboxWrapper":"checkbox_CheckboxWrapper__F61mw"};